export default __webpack_public_path__ + "static/media/banking_2.304edf68.png";